import { useMutation } from '@tanstack/react-query';
import { addFeedback, addTicket } from './api';
import { ErrorResponse } from '@shared/api';
import { TCreateTicketRequest, TFeedbackRequest } from './type';

export const useAddTicket = () =>
  useMutation<void, ErrorResponse, TCreateTicketRequest>({
    mutationFn: (data) => addTicket(data),
  });

export const useAddFeedBack = () =>
  useMutation<void, ErrorResponse, TFeedbackRequest>({
    mutationFn: (data) => addFeedback(data),
  });
